















































































































































































































































































































// import Vue from 'vue';
import { VNode, CreateElement } from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { SwTable, TableColumnConfig, TableEntryExpandingEventData, TableEntryFloatAction, TableEntry, ColumnSortRequestData, SortedColumnInfo } from '@libs-uuif/shared/sw-table';
import  { MswApiService } from '@/shared/msw-api-service';
import { SwSelect, SelectOption } from '@libs-uuif/shared/sw-select';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import { SwTextarea, SwTextfield, SwExpandableTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwForm, SwFormRow } from '@libs-uuif/shared/sw-form';
import { SwContentToolbar, SwContentToolbarExpand, ContentToolbarExpandFilterBlock } from '@libs-uuif/shared/sw-content-toolbar';
import { SwRadio } from '@libs-uuif/shared/sw-radio';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { SwModal, SwModalBody } from '@libs-uuif/shared/sw-modal';
import { InfoState } from '@/core/core.store';
import { SwTitlePane } from '@libs-uuif/shared/sw-title-pane';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';
import { tooltip, TooltipDirValues } from '@libs-uuif/shared/tooltip-dir';
import ExportcsvService from '@/shared/msw-exportcsv.service';
import { currentUserKey } from '@/shared/msw-constants';
import { MswAppTitle } from '@/shared/msw-app-title';
import DownloadCenterChildTable from './components/download-center-child-table.component.vue';
import _ from 'lodash';

const cssPrefix = 'download-center';
@Component({
  components: {
    ...UUIFComponents,
    SwButton,
    SwTable,
    SwSelect,
    SwCheckbox,
    SwForm,
    SwFormRow,
    SwTextarea,
    SwContentToolbar,
    SwContentToolbarExpand,
    SwRadio,
    SwIconButton,
    SwIcon,
    SwModal,
    SwModalBody,
    SwTitlePane,
    SwTextfield,
    SwScrollView,
    MswAppTitle,
    SwExpandableTextfield,
  }, directives: {
    tooltip,
  },
})
export default class MswDownloadCenter extends SwExtendedVue {
  cssPrefix =  cssPrefix;
  downloadCenterData: any = [];
  searchInputText : string = '';
  @Watch('searchInputText')
  searchInputTextChanged(val: any) {
    if (val === '') {
      this.filterApplied = false;
    }
  }
  filterColumnKey: string = '';
  filterColumnValue: string = '';
  sortedColumns: SortedColumnInfo[] = [];
  isExpandSearchFilter : boolean = false;
  filteredDownloadCenterData: any = [];
  filterApplied: boolean = false;
  checkForTerms: boolean = false;
  termsAndConditionFlag: boolean = false;
  termsAndCondition: string = '';
  langSelected: string = '';
  apecPlatform: string = '';
  langOptions: [SelectOption] = [{ id: '', value: '', label: '' }];
  platformOptions: [SelectOption] = [{ id: '', value: '', label: '' }];
  termsAndConditionText: string = '';
  expandVisible: boolean = false;
  userName: string = '';

  getApplicableDownloadsParams: any = {
    category: 'LATEST',
    productType: '',
    swLangCode: 'EN',
    fileType: ['Firmware', 'DOC'],
    releaseType: '',
    keyWord:'',
    previousVersions:false,
    softwareGroupID:'',
    isFileTypeChange:false,
    username: this.userName,
  };
  productTypeOptions: SelectOption[] = [];
  languageOptions:SelectOption[] = [];
  releaseTypeOptions:SelectOption[] = [];
  nameFilter:string = '';
  releaseTypeFilter:string = '';
  versionFilter:string = '';
  releaseDateFilter:string = '';
  eosDateFilter:string = '';
  fileTypeFilter:string = '';
  languageFilter:string = '';

  enableInfo: boolean = false;
  enableAPEC: boolean = false;
  softwareTypeOptions: any = [];
  selectedSoftwareOption: any = [];
  dataToBePostedForSoftwareTypeChange: any = {};
  searchApecString: string = '';
  apecData: any = [];
  apecAvastData: any = [];
  selectedFileName: string = '';
  apecFileName: string = '';
  apecVersion: string = '';
  enablePlatformToolTip: boolean = false;
  platformToolTipContent: string = '';
  enableSoftwareTypeTooltip: boolean = false;
  softwareTypeToolTipContent: string = '';
  apecTableDataRecieved: any = [];

  onToggleFilterExpand() {
    this.expandVisible = !this.expandVisible;
  }

  get categoryOptions() {
    return [
      { id: 'LATEST', value: 'LATEST', label: (this.$t('downloadcenter.latestVersions')
      .toString()) },
      { id: 'ALL', value: 'ALL', label: (this.$t('downloadcenter.allVersion')
      .toString()) },
      { id: 'MYDOWNLOADS', value: 'MYDOWNLOADS', label: (this.$t('downloadcenter.customDownloads')
      .toString()) },
    ];
  }

  handleSearchFilter() {
    if (this.searchInputText.trim() === '') {
      return;
    }
    this.filteredDownloadCenterData = _.filter(this.downloadCenterData, (o : any) => {
      let flag = false;
      if (o.name.toLowerCase()
      .indexOf(this.searchInputText.toLowerCase()) > -1 || o.releaseType.toLowerCase()
      .indexOf(this.searchInputText.toLowerCase()) > -1 || o.version.toLowerCase()
      .indexOf(this.searchInputText.toLowerCase()) > -1 || o.releaseDate.toLowerCase()
      .indexOf(this.searchInputText.toLowerCase()) > -1 || o.fileType.toLowerCase()
      .indexOf(this.searchInputText.toLowerCase()) > -1 || o.languageCode.toLowerCase()
      .indexOf(this.searchInputText.toLowerCase()) > -1) {
        flag = true;
      }
      if (flag) {
        return o;
      }
    }) as TableEntry[];
    this.filterApplied =  true;
  }

  applyFilters() {
    this.filteredDownloadCenterData = _.filter(this.downloadCenterData, (o : any) => {
      let flag = true;
      if (this.nameFilter !== '' && o.name.toLowerCase()
      .indexOf(this.nameFilter.toLowerCase()) === -1) {
        flag = false;
      }
      if (this.releaseTypeFilter !== '' && o.releaseType.toLowerCase()
      .indexOf(this.releaseTypeFilter.toLowerCase()) === -1) {
        flag = false;
      }
      if (this.versionFilter !== '' && o.version.toLowerCase()
      .indexOf(this.versionFilter.toLowerCase()) === -1) {
        flag = false;
      }
      if (this.releaseDateFilter !== '' && o.releaseDate.toLowerCase()
      .indexOf(this.releaseDateFilter.toLowerCase()) === -1) {
        flag = false;
      }
      if (this.eosDateFilter !== '' && o.firmwareEndDate.toLowerCase()
      .indexOf(this.eosDateFilter.toLowerCase()) === -1) {
        flag = false;
      }
      if (this.fileTypeFilter !== '' && o.fileType.toLowerCase()
      .indexOf(this.fileTypeFilter.toLowerCase()) === -1) {
        flag = false;
      }
      if (this.languageFilter !== '' && o.languageCode.toLowerCase()
      .indexOf(this.languageFilter.toLowerCase()) === -1) {
        flag = false;
      }
      if (flag) {
        return o;
      }
    }) as TableEntry[];
    this.filterApplied =  true;
  }

  mutateFilterState(name: any, event: any) {
    switch (name) {
      case 'name':
        this.nameFilter = event;
        break;
      case 'releaseType':
        this.releaseTypeFilter = event;
        break;
      case 'version':
        this.versionFilter = event;
        break;
      case 'releaseDate':
        this.releaseDateFilter = event;
        break;
      case 'eosDate':
        this.eosDateFilter = event;
        break;
      case 'fileType':
        this.fileTypeFilter = event;
        break;
      case 'language':
        this.languageFilter = event;
        break;
      case 'searchInputText':
        this.searchInputText = event;
        break;
    }
    if (!this.nameFilter && !this.releaseTypeFilter && !this.versionFilter && !this.releaseDateFilter && !this.eosDateFilter  && !this.fileTypeFilter && !this.languageFilter && !this.searchInputText) {
      this.filterApplied = false;
    }
  }

  private viewNameRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'name',
              value: this.nameFilter,
              placeholder: (this.$t('downloadcenter.name')
              .toString()),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('name', event);
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }
  private viewReleaseTypeRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'releaseType',
              value: this.releaseTypeFilter,
              placeholder: (this.$t('downloadcenter.releaseType')
              .toString()),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('releaseType', event);
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }
  private viewVersionRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'version',
              value: this.versionFilter,
              placeholder: (this.$t('downloadcenter.version')
              .toString()),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('version', event);
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }
  private viewReleaseDateRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'releaseDate',
              value: this.releaseDateFilter,
              placeholder: (this.$t('downloadcenter.releaseDate')
              .toString()),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('releaseDate', event);
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }
  private viewEosDateRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'eosDate',
              value: this.eosDateFilter,
              placeholder: this.$t('downloadcenter.eosDate')
              .toString(),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('eosDate', event);
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }
  private viewFileTypeRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'fileType',
              value: this.fileTypeFilter,
              placeholder: (this.$t('downloadcenter.fileType')
              .toString()),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('fileType', event);
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }
  private viewLanguageRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'language',
              value: this.languageFilter,
              placeholder: (this.$t('downloadcenter.language')
              .toString()),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('language', event);
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }

  get filterBlockGrid() : ContentToolbarExpandFilterBlock[][] {
    const tableHeader = document.querySelector('.msw-table-toolbar') as HTMLElement;
    let totalWidth = 0;
    if (tableHeader) {
      totalWidth = tableHeader.getBoundingClientRect().width;
    }
    return [
      [
        { title: (this.$t('downloadcenter.name')
        .toString()), content: this.viewNameRender, width: totalWidth / 7 || 250 },
        { title: (this.$t('downloadcenter.releaseType')
        .toString()), content: this.viewReleaseTypeRender, width: totalWidth / 7 || 250 },
        { title: (this.$t('downloadcenter.version')
        .toString()), content: this.viewVersionRender, width: totalWidth / 7 || 250 },
        { title: (this.$t('downloadcenter.releaseDate')
        .toString()), content: this.viewReleaseDateRender, width: totalWidth / 7 || 250 },
        { title: (this.$t('downloadcenter.eosDate')
        .toString()), content: this.viewEosDateRender, width: totalWidth / 7 || 250 },
        { title: (this.$t('downloadcenter.fileType')
        .toString()), content: this.viewFileTypeRender, width: totalWidth / 7 || 250 },
        { title: (this.$t('downloadcenter.language')
        .toString()), content: this.viewLanguageRender, width: totalWidth / 7 || 250 },
      ],
    ];
  }

  async onOptionsChange(type: String) {
    if (type === 'lang') {
      await this.loadApplicableSoftwareGroups();
      await this.setSelectedOptions();
    }
    await this.loadDownloadCenterData();
  }

  get downloadCenterColumnsConfig(): TableColumnConfig[] {
    return [{
      key: 'index',
      type: 'index',
    },
    {
      key: 'expand',
      type: 'expand',
      typedCellTooltip: ((entry) => {
        const expandedEntries = Array.from(this.expandedEntries);
        const selectedIcon = document.querySelector(`.expandIcon-${entry._key}`);
        if (expandedEntries?.length > 0 && expandedEntries.indexOf(entry._key) >= 0) {
          selectedIcon?.setAttribute('title', 'Collapse');
        } else {
          selectedIcon?.setAttribute('title', 'Expand');
        }
      }),
      className: ((entry) => {
        return `expandIcon-${entry._key}`;
      }),
      // tslint:disable-next-line
      render: (h: CreateElement, data: any): VNode => {
        this.apecVersion = data.entry.version;
        return (
          <div style="margin: 2rem">
            <DownloadCenterChildTable downloadCenterData={data.entry} onEnableInfo={() => { this.enableInfo = true; }} onGetApecInfo={ this.getApecInfo }/>
          </div>
        ) as VNode;
      },
    },
    {
      key: 'name',
      dataKey: 'name',
      title: (this.$t('downloadcenter.name')
      .toString()),
      sorter: true,
    }, {
      key: 'releaseType',
      dataKey: 'releaseType',
      title: (this.$t('downloadcenter.releaseType')
      .toString()),
      sorter: true,
      // tslint:disable-next-line
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
        {
          return (
            <div
              style={{ display: 'flex', flex: '1', alignItems: 'center' }}
              on-mouseover={() => {
                this.filterColumnKey = data.entry._key;
                this.filterColumnValue = data.entry.releaseType;
              }}
              on-mouseleave={() => (this.filterColumnKey = '')}
            >
              {data.entry.releaseType}

              {this.filterColumnKey === data.entry._key &&
                this.filterColumnValue === data.entry.releaseType && (
                  <SwIcon
                    name="filter"
                    size={12}
                    style={{ marginLeft: '5px' }}
                    v-tooltip={{ content: (this.$t('downloadcenter.addFilter')
                    .toString()), compact: true, placement: 'bottom' }}
                    nativeOn-click={() => {
                      this.expandVisible = true;
                      this.releaseTypeFilter = data.entry.releaseType;
                      this.applyFilters();
                    }}
                  ></SwIcon>
                )}
            </div>
          ) as VNode;
        }
      },
    },
    {
      key: 'version',
      dataKey: 'version',
      title: (this.$t('downloadcenter.version')
      .toString()),
      sorter: ((a: any, b: any) => {
        return a.intVersion - b.intVersion;
      }),
      // tslint:disable-next-line
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
        {
          return (
            <div
              style={{ display: 'flex', flex: '1', alignItems: 'center' }}
              on-mouseover={() => {
                this.filterColumnKey = data.entry._key;
                this.filterColumnValue = data.entry.version;
              }}
              on-mouseleave={() => (this.filterColumnKey = '')}
            >
              {data.entry.version}

              {this.filterColumnKey === data.entry._key &&
                this.filterColumnValue === data.entry.version && (
                  <SwIcon
                    name="filter"
                    size={12}
                    style={{ marginLeft: '5px' }}
                    v-tooltip={{ content: (this.$t('downloadcenter.addFilter')
                    .toString()), compact: true, placement: 'bottom' }}
                    nativeOn-click={() => {
                      this.expandVisible = true;
                      this.versionFilter = data.entry.version;
                      this.applyFilters();
                    }}
                  ></SwIcon>
                )}
            </div>
          ) as VNode;
        }
      },
    },
    {
      key: 'releaseDate',
      dataKey: 'releaseDate',
      title: (this.$t('downloadcenter.releaseDate')
      .toString()),
      sorter: ((a: any, b: any) => {
        const aReleaseDate: any = new Date(a.releaseDate);
        const bReleaseDate: any = new Date(b.releaseDate);
        return aReleaseDate - bReleaseDate;
      }),
      // tslint:disable-next-line
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
        {
          return (
            <div
              style={{ display: 'flex', flex: '1', alignItems: 'center' }}
              on-mouseover={() => {
                this.filterColumnKey = data.entry._key;
                this.filterColumnValue = data.entry.releaseDate;
              }}
              on-mouseleave={() => (this.filterColumnKey = '')}
            >
              {data.entry.releaseDate}

              {this.filterColumnKey === data.entry._key &&
                this.filterColumnValue === data.entry.releaseDate && (
                  <SwIcon
                    name="filter"
                    size={12}
                    style={{ marginLeft: '5px' }}
                    v-tooltip={{ content: (this.$t('downloadcenter.addFilter')
                    .toString()), compact: true, placement: 'bottom' }}
                    nativeOn-click={() => {
                      this.expandVisible = true;
                      this.releaseDateFilter = data.entry.releaseDate;
                      this.applyFilters();
                    }}
                  ></SwIcon>
                )}
            </div>
          ) as VNode;
        }
      },
    },
    {
      key: 'firmwareEndDate',
      dataKey: 'firmwareEndDate',
      /* tslint:disable-next-line */
      title: (h: CreateElement): VNode => {
        return (
          <div style="display:flex;align-items:center;">
            <span style="margin-right:1rem;"> { this.$t('downloadcenter.eosDate')
            .toString() } </span>
            <div style="cursor:pointer;">
              <SwIcon name="informational" props-size={15} color="#47afe2" v-tooltip={{ content: this.$t('common.eosInfo'), compact: true, placement: 'bottom' }} ></SwIcon>
            </div>
          </div>
        ) as VNode;
      },
      sorter: true,
      // tslint:disable-next-line
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
        {
          return (
            <div
              style={{ display: 'flex', flex: '1', alignItems: 'center' }}
              on-mouseover={() => {
                this.filterColumnKey = data.entry._key;
                this.filterColumnValue = data.entry.firmwareEndDate;
              }}
              on-mouseleave={() => (this.filterColumnKey = '')}
            >
              <span style={ data.entry.firmwareStatus === 'ACTIVE' ? '' : 'color: red' }> {data.entry.firmwareEndDate} </span>

              {this.filterColumnKey === data.entry._key &&
                this.filterColumnValue === data.entry.firmwareEndDate && (
                  <SwIcon
                    name="filter"
                    size={12}
                    style={{ marginLeft: '5px' }}
                    v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                    nativeOn-click={() => {
                      this.expandVisible = true;
                      this.eosDateFilter = data.entry.firmwareEndDate;
                      this.applyFilters();
                    }}
                  ></SwIcon>
                )}
            </div>
          ) as VNode;
        }
      },
    },
    {
      key: 'fileType',
      dataKey: 'fileType',
      title: (this.$t('downloadcenter.fileType')
      .toString()),
      sorter: true,
      // tslint:disable-next-line
      render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
        {
          return (
            <div
              style={{ display: 'flex', flex: '1', alignItems: 'center' }}
              on-mouseover={() => {
                this.filterColumnKey = data.entry._key;
                this.filterColumnValue = data.entry.fileType;
              }}
              on-mouseleave={() => (this.filterColumnKey = '')}
            >
              {data.entry.fileType}

              {this.filterColumnKey === data.entry._key &&
                this.filterColumnValue === data.entry.fileType && (
                  <SwIcon
                    name="filter"
                    size={12}
                    style={{ marginLeft: '5px' }}
                    v-tooltip={{ content: (this.$t('downloadcenter.addFilter')
                    .toString()), compact: true, placement: 'bottom' }}
                    nativeOn-click={() => {
                      this.expandVisible = true;
                      this.fileTypeFilter = data.entry.fileType;
                      this.applyFilters();
                    }}
                  ></SwIcon>
                )}
            </div>
          ) as VNode;
        }
      },
    },
    {
      key: 'languageCode',
      dataKey: 'languageCode',
      title: (this.$t('downloadcenter.languageCode')
      .toString()),
    }];
  }

  get apecColumnsConfig(): TableColumnConfig[] {
    return [{
      key: 'index',
      type: 'index',
    },
    {
      key: 'supportService',
      dataKey: 'supportService',
      title: (this.$t('downloadcenter.supportedService')
      .toString()),
    },
    {
      key: 'supportedVersion',
      dataKey: 'supportedVersion',
      title: (this.$t('downloadcenter.supportedVersion')
      .toString()),
    }];
  }
  /* tslint:disable-next-line */
  getFloatActions(entry: TableEntry,index: number, scope: any = this): TableEntryFloatAction[] {
    if (index === -1) { return []; }
    return [
      {
        icon: { name: 'app-add' },
        action(entry: TableEntry) {
          scope.addToCustomDownloads(entry.softwareGroupID, entry.addMyDownload);
        },
        tooltip: { content: entry.addMyDownload ? (this.$t('downloadcenter.AddToCustomDownloads')
      .toString()) : (this.$t('downloadcenter.RemoveFromCustomDownloads')
      .toString()), compact: true },
      },
    ];
  }

  expandedEntries: Set<string> = new Set();
  shadowExpandedEntries: string[] = [];
  onEntryExpanding(data: TableEntryExpandingEventData) {
    if (data.expanding) {
      this.expandedEntries.add(data.entryKey);
    } else {
      this.expandedEntries.delete(data.entryKey);
    }
    this.shadowExpandedEntries = Array.from(this.expandedEntries);
  }

  loadDownloadCenterData() {
    this.$store.commit('startLoading');
    const { releaseType } = this.getApplicableDownloadsParams;
    this.getApplicableDownloadsParams.releaseTypeList = [{ releaseType }];
    this.getApplicableDownloadsParams.username = this.userName;
    this.downloadCenterData = [];
    let tempData: any = [];
    return new Promise((resolve) => {
      MswApiService.downloadCenter.getApplicableDownloads(this.getApplicableDownloadsParams)
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        resolve(true);
        const applicableDownloads = resp?.content?.userDownloads?.map((ele: any) => {
          return ele.applicableDownloads;
        });
        for (const i in applicableDownloads) {
          applicableDownloads[i].forEach((ele: any) => {
            tempData = {
              _key: ele.softwareGroupID,
              name: ele.name,
              name_act: ele.name_act,
              softwareGroupID: ele.softwareGroupID,
              version: ele.version,
              intVersion: ele.intVersion,
              releaseType: ele.releaseType,
              releaseDate: ele.releaseDate,
              firmwareEndDate: ele.firmwareEndDate,
              firmwareStatus: ele.firmwareStatus,
              dtreleaseDate: ele.dtreleaseDate,
              language: ele.language,
              languageCode: ele.languageCode,
              addMyDownload: ele.addMyDownload,
              removeMyDownload: ele.removeMyDownload,
              fileType: ele.fileType,
              softwareList: ele.softwareList,
            };
            this.downloadCenterData.push(tempData);
          });
        }
      });
    });
  }

  setSelectedOptions() {
    if (this.releaseTypeOptions?.length > 0 && this.productTypeOptions?.length > 0) {
      this.releaseTypeOptions?.unshift({ id: 'ALL', value: 'ALL', label: 'ALL' });
      this.getApplicableDownloadsParams.category = 'ALL';
      this.getApplicableDownloadsParams.productType = this.productTypeOptions[0].id;
      // this.getApplicableDownloadsParams.swLangCode = 'EN';
      this.getApplicableDownloadsParams.releaseType = 'ALL';
    } else {
      this.getApplicableDownloadsParams.productType = '';
      this.getApplicableDownloadsParams.releaseType = '';
      // this.downloadCenterData = [];
    }
  }

  loadApplicableSoftwareGroups() {
    this.$store.commit('startLoading');
    return new Promise((resolve) => {
      MswApiService.downloadCenter.getApplicableSoftwareGroups(this.userName, this.getApplicableDownloadsParams.swLangCode)
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        resolve(true);
        this.productTypeOptions = resp?.content?.productTypeList?.map((ele: any) => {
          return {
            id: ele.productGroupID,
            value: ele.productGroupID,
            label: ele.productTypeName,
          };
        }) || [];
        this.languageOptions = resp?.content?.languageList?.map((ele: any) => {
          return {
            id: ele.LanguageCode,
            value: ele.LanguageCode,
            label: ele.Language,
          };
        });
        this.releaseTypeOptions = resp?.content?.releaseTypeList?.map((ele: any) => {
          return {
            id: ele.releaseType,
            value: ele.releaseType,
            label: ele.releaseType,
          };
        }) || [];
      });
    });
  }

  loadActivateSoftwareDownload() {
    this.$store.commit('startLoading');
    const tempObj: any = localStorage.getItem(currentUserKey);
    const userInfoObtained: any = JSON.parse(tempObj);
    this.userName = userInfoObtained.userId;
    return new Promise((resolve) => {
      MswApiService.downloadCenter.getActivateSoftwareDownload(this.userName)
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        resolve(true);
        this.checkForTerms = resp.hasOwnProperty('content');
        this.langOptions = resp.hasOwnProperty('content') ?
        resp.content.hasOwnProperty('languageList') ? resp.content.languageList.map((ele: any) => {
          return {
            id: String(ele.choidID),
            value: String(ele.choidID),
            label: ele.Language,
          };
        }) : this.langOptions : this.langOptions;
        this.langSelected = String(this.langOptions[0].id);
        this.termsAndConditionText = resp.hasOwnProperty('content') ? resp.content.hasOwnProperty('termsNConditions') ? resp.content.termsNConditions : '' : '';
      });
    });
  }

  async triggerApis() {
    await this.loadActivateSoftwareDownload();
    await this.loadApplicableSoftwareGroups();
    await this.setSelectedOptions();
    await this.loadDownloadCenterData();
  }

  created() {
    this.triggerApis();
  }

  clickSubmit() {
    if (this.termsAndConditionFlag) {
      MswApiService.downloadCenter.postActivateSoftwareDownload(this.userName, Number(this.langSelected))
      .then(() => {
        this.loadActivateSoftwareDownload();
      });
    }
  }

  closeSearchApec() {
    this.dataToBePostedForSoftwareTypeChange.searchText = this.searchApecString || '';
    if (this.apecPlatform !== 'select') {
      if (this.selectedSoftwareOption.length > 0) {
        this.$store.commit('startLoading');
        MswApiService.downloadCenter.postGetApecSupportChart(this.dataToBePostedForSoftwareTypeChange)
        .then((resp: any) => {
          const respRecieved = resp.hasOwnProperty('content') ? resp.content.hasOwnProperty('supportVersion') ? resp.content.supportVersion : [] : [];
          this.apecTableDataRecieved = respRecieved;
          this.apecAvastData = [];
          this.selectedSoftwareOption.map((ele: any) => {
            this.apecAvastData.push({
              name: ele,
              tableData: respRecieved.filter((item: any) => item.swType === ele),
            });
          });
          // resp.hasOwnProperty('content') ? resp.content.hasOwnProperty('supportVersion') ? resp.content.supportVersion.map((ele: any) => {
          //   if (ele.swType === 'Anti-Virus') {
          //     this.apecAvastData.push({
          //       supportService: ele.supportService,
          //       supportedVersion: ele.supportService,
          //     });
          //   }
          // }) : [] : [];
          this.$store.commit('stopLoading');
        });
      } else {
        this.enableSoftwareTypeTooltip = true;
        this.softwareTypeToolTipContent = 'Select Software Type';
      }
    } else {
      this.enablePlatformToolTip = true;
      this.platformToolTipContent = 'Select platform value';
    }
  }

  onRequestSorting(data: ColumnSortRequestData) {
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  redirectToFirmware() {
    window.open('https://www.sonicwall.com/support/product-lifecycle-tables/#software-and-firmware-release-model', '_blank');
  }

  async refresh() {
    this.expandVisible = false;
    this.filterApplied = false;
    this.searchInputText = '';
    this.nameFilter = '';
    this.releaseTypeFilter = '';
    this.versionFilter = '';
    this.releaseDateFilter = '';
    this.eosDateFilter = '';
    this.fileTypeFilter = '';
    this.languageFilter = '';
    this.getApplicableDownloadsParams = {
      category: 'LATEST',
      productType: '',
      swLangCode: 'EN',
      fileType: ['Firmware', 'DOC'],
      releaseType: '',
      keyWord:'',
      previousVersions:false,
      softwareGroupID:'',
      isFileTypeChange:false,
      username: this.userName,
    };
    await this.loadApplicableSoftwareGroups();
    await this.setSelectedOptions();
    await this.loadDownloadCenterData();
  }

  onCloseModal() {
    this.enableInfo = false;
    this.enableAPEC = false;
  }

  getApecInfo() {
    this.enableAPEC = true;
    this.$store.commit('startLoading');
    MswApiService.downloadCenter.getApecPlatformOptions()
    .then((resp: any) => {
      this.apecData = resp.hasOwnProperty('content') ? resp.content.hasOwnProperty('swType') ? resp.content.swType : [] : [];
      this.platformOptions = [{ id: '-1', label: '-- Select --', value: '-1' }];
      this.platformOptions = resp.hasOwnProperty('content') ? resp.content.hasOwnProperty('platForm') ? resp.content.platForm.map((ele: any) => {
        return {
          id: ele.platForm,
          value: ele.platForm,
          label: ele.platForm,
        };
      }) : [{ id: '-1', label: '-- Select --', value: '-1' }] : [{ id: '-1', label: '-- Select --', value: '-1' }];
      this.apecPlatform = this.platformOptions[0].id;
    })
    .then(() => {
      this.checkOptions();
      this.$store.commit('stopLoading');
    });
  }

  checkOptions() {
    this.enablePlatformToolTip = false;
    this.enableSoftwareTypeTooltip = false;
    this.softwareTypeOptions = [];
    this.apecData.map((ele: any) => {
      if (ele.platForm === this.apecPlatform) {
        this.softwareTypeOptions.push({
          platForm: ele.platForm,
          softwareType: ele.softwareType,
          fileName: ele.fileName,
        });
      }
    });
  }

  addToCustomDownloads(softwareId : number, addDownload: boolean) {
    if (addDownload) {
      this.$store.commit('startLoading');
      const obj = {
        softwareGroupID: softwareId,
        username: this.userName,
      };
      MswApiService.downloadCenter.addToDownloadCenter(obj)
      .then((resp: any) => {
        if (resp.operationStatus === 'OK') {
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        } else {
          const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        }
      })
      .then(() => {
        this.loadDownloadCenterData();
        this.$store.commit('stopLoading');
      });
    } else {
      this.$store.commit('startLoading');
      const obj = {
        softwareGroupID: softwareId,
        username: this.userName,
      };
      MswApiService.downloadCenter.removeFromDownloadCenter(obj)
      .then((resp: any) => {
        if (resp.operationStatus === 'OK') {
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        } else {
          const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        }
      })
      .then(() => {
        this.loadDownloadCenterData();
        this.$store.commit('stopLoading');
      });
    }
  }

  softwareTypeChange(obj: any) {
    if (this.selectedSoftwareOption.length > 0) {
      this.enableSoftwareTypeTooltip = false;
    }
    this.apecFileName = obj.platform;
    this.dataToBePostedForSoftwareTypeChange = {
      platform: this.apecPlatform,
      searchText: this.searchApecString,
      swType: [],
      version: '17.04.19.11',
    };
    this.selectedSoftwareOption.map((ele: any) => {
      this.dataToBePostedForSoftwareTypeChange.swType.push({
        platForm : this.apecPlatform,
        softwareType: ele,
        fileName: this.apecFileName,
        checked: true,
      });
    });
  }

  get platformTooltipValue() : TooltipDirValues  {
    return {
      enabled: this.enablePlatformToolTip,
      placement: 'right',
      persistent: true,
      compact: true,
      content: this.platformToolTipContent,
    };
  }

  get softwareTooltipValue() : TooltipDirValues  {
    return {
      enabled: this.enableSoftwareTypeTooltip,
      placement: 'right',
      persistent: true,
      compact: true,
      content: this.softwareTypeToolTipContent,
    };
  }

  exportCsv() {
    ExportcsvService.startExport(this.mapDataForExport(this.apecAvastData), 'SupportChart.csv');
  }

  mapDataForExport(data: any[]) {
    let tempArr: any = [];
    const itemHeader = ['Supported Service', 'Supported Versions'];
    data.map((dataItem:any) => {
      const tempJson: any = [{ '' : '' }, { 'software type' : dataItem.name }, { '' : '' }, itemHeader];
      dataItem.tableData.map((key: any) => {
        const obj = {};
        this.apecColumnsConfig.forEach((item) => {
          if (item.dataKey) {
            // @ts-ignore
            obj[item.title] = key[item.dataKey];
          }
        });
        tempJson.push(obj);
      });
      tempArr = tempArr.concat(tempJson);
    });
    return tempArr;
  }
}
